import React from 'react'
import styled from 'styled-components'

import logoPoupaEnergia from './logo-poupa-energia.png'
import logoAdene from './logo-adene.png'

/**
 * Cabeçalho da página de avaliação (versão simplificada do header do portal).
 *
 * Réplica do header.html mas SEM a "Área Reservada / Entrar": o objetivo é que
 * o utilizador preencha o inquérito, não que saia para a área reservada.
 * Mantém apenas os logos (Poupa Energia + ADENE) à esquerda.
 */
export default function RatingHeader() {
  return (
    <Header>
      <Inner>
        <a
          href='https://poupaenergia.pt/'
          target='_blank'
          rel='noopener noreferrer'>
          <PoupaLogo src={logoPoupaEnergia} alt='Logo do Poupa Energia' />
        </a>
        <a
          href='https://www.adene.pt/'
          target='_blank'
          rel='noopener noreferrer'>
          <AdeneLogo
            src={logoAdene}
            alt='Logo da ADENE Agência para a Energia'
          />
        </a>
      </Inner>
    </Header>
  )
}

const Header = styled.header`
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #ececec;
`

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  gap: 40px;
`

const PoupaLogo = styled.img`
  height: 44px;
  width: auto;
  display: block;
`

const AdeneLogo = styled.img`
  height: 40px;
  width: auto;
  display: block;
`



// WEBPACK FOOTER //
// ./src/components/RatingHeader/index.js